import { useEffect, startTransition } from 'react';
import { useAtom } from 'jotai';
import { useLocation, useNavigate } from 'react-router-dom';
import { activeVersionAtom } from '../atoms/assistiveTouchAtoms';
import { updateThemeColorMeta, getCurrentTheme } from '../utils/themeUtils';

/**
 * 版本路由钩子
 * 监听 activeVersionAtom 变化，自动切换路由
 */
export const useVersionRouter = () => {
  const [activeVersion, setActiveVersion] = useAtom(activeVersionAtom);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // 从当前路径中提取版本信息
    const pathSegments = location.pathname.split('/');
    const currentVersion = pathSegments.length > 1 && /^v[0-3]$/.test(pathSegments[1])
      ? pathSegments[1]
      : null;

    // 如果路径中的版本与当前激活版本不同，则更新激活版本
    if (currentVersion && currentVersion !== activeVersion) {
      setActiveVersion(currentVersion);
    }
  }, [location.pathname, activeVersion]);

  // 切换版本的函数
  const switchVersion = (version: string) => {
    if (version === activeVersion) return;

    // 使用React.startTransition包装状态更新和导航
    startTransition(() => {
      // 先更新版本状态
      setActiveVersion(version);

      // 更新主题颜色
      updateThemeColorMeta(getCurrentTheme(), version);

      // 导航到对应版本的首页
      const pathSegments = location.pathname.split('/');

      // 如果当前路径已经包含版本信息，则替换
      if (pathSegments.length > 1 && /^v[0-3]$/.test(pathSegments[1])) {
        pathSegments[1] = version;
        navigate(pathSegments.join('/'));
      } else {
        // 否则导航到该版本的默认页面
        navigate(`/${version}/tasks`);
      }
    });

    // 记录版本切换日志
    console.log(`[useVersionRouter] Switching from ${activeVersion} to ${version}`);
  };

  return { activeVersion, switchVersion };
};

export default useVersionRouter;
